<template>
  <div class="body">
    <el-card class="box-card">
      <el-form ref="form" :rules="rules" :model="form" label-width="140px">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试名称" prop="examName" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.examName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试地点" prop="examLocation">
               <el-input disabled v-model="form.examLocation"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="合格分数" prop="passingScore">
              <el-input
                disabled
                type="number"
                v-model="form.passingScore"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="总分数" prop="fraction" class="item">
              <el-input
                disabled
                type="number"
                v-model="form.fraction"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item
              label="考试时长(分钟)"
              prop="examDuration"
              class="item"
            >
              <el-input
                type="number"
                disabled
                v-if="form.examDuration &&  form.examDuration > 0"
                v-model="form.examDuration"
                placeholder="请输入考试时长（分钟）"
              ></el-input>
              <el-input
                v-else
                disabled
                :value="'--'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试次数" prop="examFrequency" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                type="number"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                v-model="form.examFrequency"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="考试时间" prop="date" class="item">
              <el-date-picker
                :disabled="$route.query.type == 'check'"
                v-model="form.date"
                :picker-options="pickerOption"
                :editable="false"
                :clearable="false"
                type="datetimerange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试类型" prop="examType">
              <el-select
                :disabled="$route.query.type == 'check'"
                v-model="form.examType"
                placeholder="请选择"
              >
                <el-option
                  :label="item.text"
                  :value="item.code"
                  v-for="(item, index) in examTypeList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="是否需要签到" prop="isSignin" class="item">
              <el-switch
                :disabled="$route.query.type == 'check'"
                active-value="0"
                inactive-value="1"
                v-model="form.isSignin"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item
              label="是否随机排序"
              prop="upsetQuestions"
              class="item"
            >
              <el-switch
                :disabled="$route.query.type == 'check'"
                active-value="0"
                inactive-value="1"
                v-model="form.upsetQuestions"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-form-item>
          <el-button type="primary">搜索</el-button>
          <el-button type="primary">重置</el-button>
        </el-form-item>-->

        <h2 class="body-title">试卷详情</h2>
        <el-button
          v-if="type != 'check'"
          type="primary"
          @click="paperVisible = true"
          >点击选择试卷</el-button
        >
        <el-table class="mb20" :data="selectPaperList" style="width: 100%">
          <el-table-column
            prop="questionsPaperName"
            label="试卷名称"
          ></el-table-column>
          <el-table-column prop="date" label="试卷类型">
            <template slot-scope="scope">{{
              scope.row.selectionMode == 0 ? "随机试题" : "固定试题"
            }}</template>
          </el-table-column>
          <!-- <el-table-column prop="date" label="所属部门"></el-table-column> -->
          <el-table-column
            prop="questionNumber"
            label="包含题目数量"
          ></el-table-column>
        </el-table>

        <h2 class="body-title">考试人员</h2>
        <el-button
          v-if="type != 'check'"
          type="primary"
          @click="addPerson()"
          >点击选择人员</el-button
        >
        <el-table :data="personList" style="width: 100%" class="mb20" height="356">
          <el-table-column label="序号">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="label" label="对象名称"></el-table-column>
          <el-table-column label="操作" v-if="type != 'check'">
            <template slot-scope="scope">
              <el-button size="small" type="danger" @click="delPerson(scope.$index)"
                >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button v-if="type != 'check'" :loading="saveLoading"
                    type="primary" @click="save"
          >保存</el-button
        >
        <el-button @click="$router.go(-1)">取消</el-button>
      </el-form>
    </el-card>

    <!-- 选择试卷弹窗 -->
    <el-dialog title="关联考试" :visible.sync="paperVisible" width="70%">
      <el-form
        ref="paperForm"
        label-width="100px"
        :model="paperForm"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="试卷类型" prop="selectionMode">
              <el-select v-model="paperForm.selectionMode">
                <el-option label="随机试题" value="0"></el-option>
                <el-option label="固定试题" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试卷名称" prop="questionsPaperName">
              <el-input v-model="paperForm.questionsPaperName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button type="primary" @click="getPaperList">搜索</el-button>
              <el-button type="primary" @click="resetForm('paperForm')"
                >重置</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="paperList" style="width: 100%" height="450">
        <el-table-column label="请选择">
          <template slot-scope="scope">
            <el-radio v-model="selectPaperIndex" :label="scope.$index"
              >选择试卷</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="questionsPaperName"
          label="试卷名称"
        ></el-table-column>
        <el-table-column prop="date" label="试卷类型">
          <template slot-scope="scope">{{
            scope.row.selectionMode == 0 ? "随机试题" : "固定试题"
          }}</template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="所属部门"></el-table-column> -->
        <el-table-column
          prop="questionNumber"
          label="包含题目数量"
        ></el-table-column>
      </el-table>

      <span slot="footer" class="f-b-c">
        <div></div>
        <div>
          <el-button @click="paperVisible = false">取 消</el-button>
          <el-button type="primary" @click="paperComfirm">确 定</el-button>
        </div>
      </span>
    </el-dialog>

    <!-- 选择培训人员弹窗 -->
    <el-dialog title="选择用户" :visible.sync="personVisible" width="70%">
      <div class="f-c">
        <div style="heigth:100%;margin-right:100px;">
          <div class="mb10">
            <el-radio v-model="userSelection" label="0">用户</el-radio>
            <el-radio v-model="userSelection" label="1">部门</el-radio>
            <el-radio v-model="userSelection" label="2">岗位</el-radio>
            <el-radio v-model="userSelection" label="3">角色</el-radio>
          </div>

          <el-tree
            v-show="userSelection == 0"
            :props="props"
            :data="deptTree"
            show-checkbox
            @check-change="treeChange1"
          ></el-tree>
          <el-tree
            v-show="userSelection == 1"
            :props="props"
            :data="deptTree"
            show-checkbox
            @check-change="treeChange2"
          ></el-tree>
          <div v-show="userSelection == 3">
            <el-checkbox-group v-model="selectRoleList">
              <div v-for="(item, index) in roleList" :key="index">
                <el-checkbox :label="index">{{ item.roleName }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>

        <el-transfer
          v-show="userSelection == 0"
          :titles="['未选择', '已选择']"
          :data="transferData1"
          v-model="transferModel1"
        ></el-transfer>
        <el-transfer
          v-show="userSelection == 1"
          :titles="['未选择', '已选择']"
          :data="transferData2"
          v-model="transferModel2"
        ></el-transfer>
        <el-transfer
          v-show="userSelection == 3"
          :titles="['未选择', '已选择']"
          :data="transferData4"
          v-model="transferModel4"
        ></el-transfer>
      </div>

      <span slot="footer" class="f-b-c">
        <div></div>
        <div>
          <el-button @click="personVisible = false">取 消</el-button>
          <el-button type="primary" @click="selectPersonComfirm"
            >确 定</el-button
          >
        </div>
      </span>
    </el-dialog>

    <userSelection ref="userSelection" @submit="selectPersonComfirm"></userSelection>
  </div>
</template>

<script>
/**
examName: "考试名称",
examLocation: "考试地点",
passingScore: "通过分数(Int)",
startTime: "考试开始时间",
endTime: "考试结束时间",
examType: "考试类型",
fraction: "总分数",
examDuration: "考试时长",
isSignin: "是否需要签到",
upsetQuestions: "是否随机排序",
examFrequency: "考试次数",

paperId: "试卷Id",
paperName: "试卷名称",
paperType: "试卷类型",
department: "所属部门",
questionsNumber: "包含题目数",
 */
import exam from "@/api/new/exam.js";
import api_user from "@/api/api_user.js";
import api_role from "@/api/api_role.js";
import userSelection from '@/pages/trainingManagement/component/user/userSelection.vue';


export default {
  components: {userSelection},
  data() {
    return {
      paperForm: {},
      form: {
        examName: undefined,
        examLocation: '线上考试',
        passingScore: undefined,

        startTime: undefined,
        endTime: undefined,

        examType: undefined,
        fraction: undefined,
        examDuration: undefined,
        isSignin: undefined,
        upsetQuestions: undefined,
        examFrequency: 1,

        paperName: undefined,
        paperId: undefined,
        paperType: undefined,
        department: undefined,
        questionsNumber: undefined
      },
      rules: {
        examName: [{ required: true, message: "请输入试卷名称", trigger: "blur" }],
        examLocation: [{ required: true, message: "请输入合格分数", trigger: "blur" }],
        passingScore: [{ required: true, message: "请输入通过分数" }],
        examType: [{ required: true, message: "请输入考试类型" }],
        fraction: [{ required: true, message: "请输入总分数" }],
        examDuration: [{ required: true, message: "请选择考试时间" }],
        examFrequency: [{ required: true, message: "请选择考试类型", trigger: "blur" }],
        date: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      props: {
        label: "text",
        children: "children"
      },
      principalList: [], // 负责人列表
      paperList: [],
      selectPaperList: [],
      personList: [],

      paperVisible: false,
      personVisible: false,
      selectPaperIndex: 0,
      type: "",

      userSelection: "0",
      deptTree: [],
      programDetail: {},
      transferData1: [], // 穿梭框左边边的数据
      transferModel1: [], // 穿梭框右边的数据
      transferData2: [], // 穿梭框左边边的数据
      transferModel2: [], // 穿梭框右边的数据
      transferData3: [], // 穿梭框左边边的数据
      transferModel3: [], // 穿梭框右边的数据
      transferData4: [], // 穿梭框左边边的数据
      transferModel4: [], // 穿梭框右边的数据
      roleList: [],
      selectRoleList: [],
      examTypeList: [],
      saveLoading: false,

      // 控制时间选择范围，限制只能选择 今天以及以后的时间
      pickerOption: {
        disabledDate(time) {
          let cdate =  new Date();
          if (time.getFullYear() < cdate.getFullYear() ) {
            return true;
          }
          if (time.getFullYear() == cdate.getFullYear() && time.getMonth() < cdate.getMonth()){
            return true;
          }
          if ( time.getFullYear() == cdate.getFullYear() && time.getMonth() == cdate.getMonth() && time.getDate() <  cdate.getDate()){
            return true;
          }
          return false;
        }
      }

    };
  },
  mounted() {
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    this.principalList = JSON.parse(localStorage.getItem( "principalList"));
    this.examTypeList = JSON.parse(localStorage.getItem("exam_type"));
    this.getPaperList();
    this.getNewExamDetail();
    this.getRole();
  },
  methods: {
    addPerson(){
      this.$refs.userSelection.show(this.personList);
    },
    getRole() {
      api_role
        .findList({
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.roleList = res.rows;
        });
    },
    getNewExamDetail() {
      let id = this.$route.query.id;
      this.type = this.$route.query.type;
      if (!id) return;
      exam.getNewExamDetail({ id }).then(res => {
        this.form = {
          ...res.data
        };
        this.form.isSignin = String(this.form.isSignin);
        this.form.examType = String(this.form.examType);
        this.form.upsetQuestions = String(this.form.upsetQuestions);
        this.form.date = [
          new Date(res.data.startTimeString).getTime(),
          new Date(res.data.endTimeString).getTime()
        ];

        this.selectPaperList = [
          {
            paperId: res.data.paperId,
            questionsPaperName: res.data.paperName,
            paperType: res.data.paperType,
            selectionMode: res.data.paperType,
            department: "所属部门",
            questionNumber: res.data.questionsNumber
          }
        ];


        res.data.tasksJoinUsers.forEach(v => {
          this.personList.push({
            label: v.busiName
          });
        });
      });
    },
    save() {
      this.$refs.form.validate(validate => {
        if (validate == false) return this.$message.error("请填写表单");
        if (this.selectPaperList.length == 0)
          return this.$message.error("请选择试卷");
        if (this.personList.length == 0)
          return this.$message.error("请选择考试人员");
        let p = {
          ...this.form,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId,
          paperId: this.selectPaperList[0].id,
          paperName: this.selectPaperList[0].questionsPaperName,
          paperType: this.selectPaperList[0].selectionMode,
          department: "所属部门",
          questionsNumber: this.selectPaperList[0].questionNumber,
          trainingTasksJoinUser: []
        };

        if (p.date && p.date.length > 0) {
          p.startTime = p.date[0];
          p.endTime = p.date[1];
          delete p.date;
        } else {
          this.$message.error("请选择时间");
          throw "error";
        }

        this.personList.forEach(v => {
          p.trainingTasksJoinUser.push({
            busiId: v.key,
            busiName: v.label,
            busiType: v.personType
          });
        });

        this.examTypeList.forEach(v => {
          if (p.examType == v.code) p.examTypeString = v.text;
        });
        this.saveLoading  =  true;
        exam.examManageSave(p).then(res => {
          if (res.code == 0) {
            localStorage.setItem("issueExam", true);
            this.$message.success("成功");
            this.$router.push('/examination/examManagement');
          } else {
            this.$message.error(res.message);
            this.saveLoading =  false;
          }
        });
      });
    },
    delPerson(index) {
      this.personList.splice(index, 1);
    },
    selectPersonComfirm(a) {
      this.personList = a;
    },
    treeChange1(data, isSelect) {
      console.log(arguments);
      api_user
        .listNopagging({
          deptId: data.id
        })
        .then(res => {
          if (isSelect) {
            res.forEach(person => {
              this.transferData1.push({
                key: person.id,
                label: person.userName
              });
            });
          } else {
            res.forEach((v, i) => {
              this.transferData1.forEach((v2, i2) => {
                if (v.id == v2.key) this.transferData1.splice(v2, 1);
              });
            });
          }
        });
    },
    treeChange2(data, isSelect) {
      if (isSelect) {
        this.transferData2.push({
          key: data.id,
          label: data.text
        });
      } else {
        this.transferData2.forEach((v, i) => {
          if (v.key == data.id) {
            this.transferData2.splice(i, 1);
          }
        });
      }
    },
    paperComfirm() {
      let paper = this.paperList[this.selectPaperIndex];
      this.selectPaperList = [paper];
      this.paperVisible = false;

      console.log(this.selectPaperList);
      this.form.passingScore = paper.gradesThroughRegulation;
      this.form.fraction = paper.fraction;
      this.form.examDuration = paper.examTime;
    },
    getPaperList() {
      exam
        .getPaperList({
          ...this.paperForm,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.paperList = res.data.records;
        });
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  watch: {
    selectRoleList(v) {
      let arr = [];
      v.forEach(item => {
        arr.push({
          key: this.roleList[item].id,
          label: this.roleList[item].roleName
        });
      });
      this.transferData4 = arr;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/examination/issueExam.vue